import cookie from 'js-cookie'
import api from "@/api";

const customer = {
  state: {
    customer: {},
  },

  mutations: {
    SET_CUSTOMER: (state, customer) => {
      state.customer = customer
    },
  },

  actions: {
    Customer({ commit }, customer) {
     commit('SET_CUSTOMER', customer)
    },
  }
}

export default customer



// WEBPACK FOOTER //
// ./src/store/modules/customer.js